import { descriptions } from "src/config/descriptions";
import { ProductType } from "src/types/product-types/ProductType";

export default function getDescriptionData(handle: string) {
  const descriptionData = descriptions.find(
    (description) => description.type === handle
  );

  if (descriptionData) {
    return descriptionData;
  } else {
    return descriptions.find(
      (description) => description.type === ProductType.Underwear
    );
  }
}
